import registration from '../../../app-registration-container'

const Modules = {
  registration,
}

export default Modules
